export default "__VITE_ASSET__DfohKNmC__"